import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'

loadFonts()
axios.defaults.baseURL = "https://kshsapi.mgemachines.com/api"
// axios.defaults.baseURL = 'http://localhost:3000/api';

axios.defaults.headers.common['Content-Type'] = 'application/json';
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
// Set the Authorization header if the token exists in localStorage
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
}

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
